import { useState } from "react";
import { format } from "date-fns";
import { Calendar as CalIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function DateRangePicker({ value, onChange }) {
  const [open, setOpen] = useState(false);
  const from = value?.from;
  const to = value?.to;

  const label = (() => {
    if (from && to) return `${format(from, "d MMM yyyy")} to ${format(to, "d MMM yyyy")}`;
    if (from) return `${format(from, "d MMM yyyy")} (choose end date)`;
    return "Select start and end dates";
  })();

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid="dates-trigger"
          className="w-full text-left input-line flex items-center justify-between cursor-pointer"
        >
          <span className="flex items-center gap-3 text-ink/85">
            <CalIcon className="w-4 h-4 text-ink/55" strokeWidth={1.2} />
            {label}
          </span>
          <span className="text-[11px] tracking-[0.16em] uppercase text-jade">Open</span>
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto bg-ivory border-mist p-4 rounded-none shadow-lg">
        <Calendar
          mode="range"
          numberOfMonths={2}
          selected={value}
          onSelect={(range) => {
            onChange(range || { from: undefined, to: undefined });
            if (range?.from && range?.to) setOpen(false);
          }}
          fromDate={new Date()}
          data-testid="date-calendar"
        />
        <div className="flex items-center justify-between pt-3 border-t border-mist/60 mt-2">
          <button
            type="button"
            onClick={() => onChange({ from: undefined, to: undefined })}
            className="text-[11px] tracking-[0.16em] uppercase text-ink/60 hover:text-jade"
          >Clear</button>
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="btn-primary text-[11px] py-2 px-5"
          >Done</button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
